import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 27426 27566"
    {...props}
  >
    <defs>
      <style>{".fil0{fill:#2b2a29}"}</style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_2528316976288">
        <path
          d="M25275 27566h-1629c-142 0-258-115-258-258V3599H4043v23709c0 143-114 258-258 258H2157c-143 0-258-115-258-258V3341c0-143 115-258 258-258h23118c143 0 258 115 258 258v23967c0 143-115 258-258 258zm-1371-516h1113V3599h-1113v23451zm-21489 0h1113V3599H2415v23451z"
          className="fil0"
        />
        <path
          d="M27171 3599H258c-143 0-258-115-258-258C0 1498 1498 0 3341 0h20743c1844 0 3342 1498 3342 3341 3 143-112 258-255 258zM528 3083h26373c-131-1436-1343-2567-2813-2567H3344C1871 516 659 1647 528 3083zM7832 24682c-143 0-258-116-258-258v-4084c0-144 115-258 258-258s258 114 258 258v4084c0 142-115 258-258 258zM10263 24682c-143 0-258-116-258-258v-1185c0-142 115-258 258-258s258 116 258 258v1185c0 142-115 258-258 258zM19600 24682c-143 0-259-116-259-258v-4084c0-144 116-258 259-258 142 0 258 114 258 258v4084c0 142-116 258-258 258zM17169 24682c-143 0-258-116-258-258v-1185c0-142 115-258 258-258s258 116 258 258v1185c0 142-115 258-258 258zM13716 7099c-143 0-258-115-258-258V5156c0-143 115-258 258-258s258 115 258 258v1685c0 143-115 258-258 258z"
          className="fil0"
        />
        <path
          d="M20815 25654c-503 0-951-211-1215-534-265 323-712 534-1216 534-503 0-948-211-1215-534-267 323-712 534-1215 534-811 0-1473-550-1473-1230V8628c0-137 108-252 245-258 2940-127 5551-799 7164-1840 81-53 180-56 264-9 84 43 134 130 134 227v17676c0 680-662 1230-1473 1230zm-1215-1489c142 0 258 116 258 259 0 394 428 714 957 714 528 0 957-320 957-714V7205c-1650 926-4074 1526-6775 1669v15550c0 394 429 714 957 714s957-320 957-714c0-143 115-259 258-259s258 116 258 259c0 394 429 714 957 714 529 0 958-320 958-714-1-143 115-259 258-259zM11478 25654c-504 0-951-211-1215-534-268 323-712 534-1215 534-504 0-951-211-1216-534-267 323-712 534-1215 534-811 0-1473-550-1473-1230V6748c0-94 53-180 133-227 84-47 184-44 265 9 1613 1041 4224 1713 7164 1840 136 6 245 121 245 258v15796c0 680-659 1230-1473 1230zm-1215-1489c143 0 258 116 258 259 0 394 429 714 957 714 529 0 957-320 957-714V8874c-2701-147-5128-746-6775-1669v17219c0 394 429 714 957 714 529 0 958-320 958-714 0-143 114-259 257-259s258 116 258 259c0 394 429 714 958 714 528 0 957-320 957-714 0-143 115-259 258-259z"
          className="fil0"
        />
        <path
          d="M13716 8908c-5713 0-10188-1958-10188-4454 0-426 133-849 397-1253 47-74 131-118 218-118h19149c87 0 168 44 218 118 264 408 397 827 397 1253-3 2499-4478 4454-10191 4454zM4286 3599c-162 283-243 572-243 855 0 2135 4429 3938 9673 3938 5243 0 9672-1803 9672-3938 0-286-80-572-242-855H4286z"
          className="fil0"
        />
        <path
          d="M13716 7099c-3313 0-5909-1163-5909-2645 0-466 258-923 749-1315 47-37 103-56 162-56h9993c59 0 115 19 161 56 491 392 749 845 749 1315 3 1482-2592 2645-5905 2645zM8811 3599c-323 277-488 566-488 855 0 1029 2167 2129 5393 2129s5392-1100 5392-2129c0-289-164-578-488-855H8811zM23646 27566H3785c-143 0-257-115-257-258s114-258 257-258h19861c143 0 258 115 258 258s-115 258-258 258z"
          className="fil0"
        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
